// Returns true if the parent element contains the child element
const contains = (parent, child) => {
  if (parent && typeof parent.contains === 'function') {
    return parent.contains(child);
  }

  return false;
};

// Get the currently active HTML element
const getActiveElement = (excludes = []) => {
  const { activeElement } = document;

  return activeElement && !excludes.some((el) => el === activeElement) ? activeElement : null;
};

// Return the Bounding Client Rect of an element
// Returns `null` if not an element
const getBCR = (el) => (isElement(el) ? el.getBoundingClientRect() : null);

// Get an style property value from an element
// Returns `null` if not found
const getStyle = (el, prop) => (prop && isElement(el) ? el.style[prop] || null : null);

// Determine if an HTML element is the currently active element
const isActiveElement = (el) => isElement(el) && el === getActiveElement();

// Attempt to focus an element, and return `true` if successful
export const attemptFocus = (el, options = {}) => {
  try {
    el.focus(options);

    return isActiveElement(el);
  } catch {
    return false;
  }
};

// Determine if an element is an HTML element
export const isElement = (el) => !!(el && el.nodeType === Node.ELEMENT_NODE);

// Determine if an HTML element is visible - Faster than CSS check
export const isVisible = (el) => {
  if (!isElement(el) || !el.parentNode || !contains(document.body, el)) {
    // Note this can fail for shadow dom elements since they
    // are not a direct descendant of document.body
    return false;
  }

  if (getStyle(el, 'display') === 'none') {
    return false;
  }
  
  const bcr = getBCR(el);

  return !!(bcr && bcr.height > 0 && bcr.width > 0);
};
